import type { ReactNode } from 'react'
import { ChevronLeft } from 'lucide-react'
import { useNav } from '@/shared/hooks/use-nav'
import { IconButton } from '@/shared/ui/icon-button'

// Contextual top app bar. `back` shows a leading chevron (pushed screens);
// top-level tab screens omit it. The title is optically centered across the
// WHOLE bar (absolute, so it never drifts with the action count) and right
// actions stay pinned to the trailing edge — identical geometry on every screen.
export function TopBar({
  title,
  actions,
  back,
  backTo = '/partidos',
}: {
  title: string
  actions?: ReactNode
  back?: boolean
  /** Where "Atrás" goes when there is no in-app history to pop. */
  backTo?: string
}) {
  const navigate = useNav()

  // The empty-history guard lives in `useNav` now — it was written here first
  // and four other navigate(-1) call sites were left behind.


  return (
    <header className="topbar safe-top sticky top-0 z-[var(--z-sticky)] bg-[var(--chrome-bg)] border-b border-[var(--chrome-line)]">
      <div className="relative h-14 px-2 flex items-center">
        {back ? (
          <IconButton label="Atrás" onClick={() => navigate(-1, { fallback: backTo })}>
            <ChevronLeft size={24} />
          </IconButton>
        ) : null}
        <h1 className="pointer-events-none absolute left-1/2 -translate-x-1/2 max-w-[60%] text-center font-bold text-[length:var(--fs-lg)] truncate">
          {title}
        </h1>
        <div className="ml-auto flex items-center justify-end gap-1 pr-1">{actions}</div>
      </div>
    </header>
  )
}
